import React from 'react';
import { parse, stringify } from 'qs';
import { withRouter } from 'react-router';

export const withToggle =
  ({ urlParamName = 'isShowToggle', defaultState = false }) =>
  (WrappedComponent) => {
    @withRouter
    class HOC extends React.PureComponent {
      state = {
        isShowData: defaultState,
      };

      componentDidMount() {
        const { location = {}, propsUrlParamName } = this.props;
        const { search = '' } = location;
        const queries = parse(search, { ignoreQueryPrefix: true });
        this.setState({
          isShowData:
            queries[propsUrlParamName || urlParamName] === 'true'
              ? true
              : queries[propsUrlParamName || urlParamName] === 'false'
              ? false
              : defaultState,
        });
      }

      toggleShow = () => {
        const { location = {}, propsUrlParamName } = this.props;
        const { search = '', pathname = '' } = location;
        const queries = parse(search, { ignoreQueryPrefix: true });
        queries[propsUrlParamName || urlParamName] = !this.state.isShowData;

        this.props.history.replace(
          `${pathname}${stringify(queries, { addQueryPrefix: true })}`,
        );

        this.setState({ isShowData: !this.state.isShowData });
      };

      render() {
        const { isShowData } = this.state;

        return (
          <WrappedComponent
            toggleShow={this.toggleShow}
            isShowData={isShowData}
            {...this.props}
          />
        );
      }
    }

    return HOC;
  };
